/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_Self_ReactionInputs */

const en_us2_club_self_reaction = /** @type {(inputs: Club_Self_ReactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reactions are for the other members.`)
};

const pt_br2_club_self_reaction = /** @type {(inputs: Club_Self_ReactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reações são para os outros membros.`)
};

const es_419_club_self_reaction = /** @type {(inputs: Club_Self_ReactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las reacciones son para los demás miembros.`)
};

const pt_pt2_club_self_reaction = /** @type {(inputs: Club_Self_ReactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As reações são para os outros membros.`)
};

const fr_fr2_club_self_reaction = /** @type {(inputs: Club_Self_ReactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les réactions sont pour les autres membres.`)
};

const de_de2_club_self_reaction = /** @type {(inputs: Club_Self_ReactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reaktionen sind für die anderen Mitglieder.`)
};

const it_it2_club_self_reaction = /** @type {(inputs: Club_Self_ReactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le reazioni sono per gli altri membri.`)
};

/**
* | output |
* | --- |
* | "Reactions are for the other members." |
*
* @param {Club_Self_ReactionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_self_reaction = /** @type {((inputs?: Club_Self_ReactionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_Self_ReactionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_self_reaction(inputs)
	if (locale === "es-419") return es_419_club_self_reaction(inputs)
	if (locale === "pt-PT") return pt_pt2_club_self_reaction(inputs)
	if (locale === "fr-FR") return fr_fr2_club_self_reaction(inputs)
	if (locale === "de-DE") return de_de2_club_self_reaction(inputs)
	if (locale === "it-IT") return it_it2_club_self_reaction(inputs)
	return en_us2_club_self_reaction(inputs)
});
export { club_self_reaction as "club.self_reaction" }